module.exports = __webpack_public_path__ + "static/media/landscape4.6c50e9f1.jpg";